import { FC } from 'react';

import { formatPrice } from 'utils/text-helpers';

export const CommissionDetailsTestIds = {
  container: 'commission-details-container',
  sellerFee: 'commission-details-sellerFee'
};

export type CommissionDetailsProps = {
  minimalFee: number;
  commission: number;
  sellingPrice: number;
  sellerFee: number;
  title?: string;
};

export const CommissionDetails: FC<CommissionDetailsProps> = ({
  commission,
  minimalFee,
  sellerFee,
  sellingPrice,
  title = 'Sale price'
}) => {
  const isMinimalFee = minimalFee >= commission;
  const formattedCommissionMinusSellerFee = formatPrice(isMinimalFee ? commission : commission - sellerFee);
  const formattedSellingPrice = formatPrice(sellingPrice);

  let formattedSellerFee = '';

  if (sellerFee === 0) {
    formattedSellerFee = 'Free';
  } else if (isMinimalFee) {
    formattedSellerFee = 'Included';
  } else {
    formattedSellerFee = `(${formatPrice(sellerFee)})`;
  }

  return (
    <div data-testid={CommissionDetailsTestIds.container} className='mt-5 riforma-regular'>
      <div className='d-flex justify-content-between mt-3'>
        <span className='mb-2'>{title}</span>
        <span>{formattedSellingPrice}</span>
      </div>
      <p className='opacity-60'>This is the price that you and the buyer will agree on should you accept the sale</p>
      <div className='d-flex justify-content-between mt-3'>
        <span className='mb-2'>Bezel Commission</span>
        <span>({formattedCommissionMinusSellerFee})</span>
      </div>
      <p className='opacity-60'>
        This helps us run the Bezel platform and offer services to support the seller experience.
      </p>
      <div data-testid={CommissionDetailsTestIds.sellerFee} className='d-flex justify-content-between mt-3'>
        <span className='mb-2'>Seller Protection</span>
        <span>{formattedSellerFee}</span>
      </div>
      <p className='opacity-60'>
        This protects against buyer fraud and insures the watch during transit to the Bezel HQ
      </p>
    </div>
  );
};
